import type { ProfileCommon } from "./profileCommon";

export type ProviderType =
  | "BEHAVIORAL"
  | "BEHAVIORAL_INTAKE"
  | "CASE_MANAGER"
  | "CASE_MANAGER_SUPERVISOR"
  | "PEER"
  | "PCP"
  | "PRESCRIBE";

export type ProviderProfile = ProfileCommon & {
  accept_new_patients: boolean;
  cp_credentials: string;
  /** SSO identity provider identifier */
  idp?: string;
  idp_logout_url?: string;
  is_edit_care_plan_enabled: boolean;
  is_universal_access_enabled: boolean;
  /** Full display name, e.g. "Dr. Jane Smith, MD" */
  name: string;
  npi_number: string;
  omnisearch_enabled: boolean;
  preferences: ProviderPreferences;
  preferred_name: Nullable<string>;
  preferred_pronouns: Nullable<string>;
  provider_type: ProviderType;
};

type ProviderPreferences = {
  is_sms_enabled?: boolean;
  time_zone: string;
};

/** Narrows a profile value to ProviderProfile at runtime */
export function isProviderProfile(profile: unknown): profile is ProviderProfile {
  return typeof profile === "object" && profile !== null && "provider_type" in profile;
}
